import { useParams } from "react-router-dom";

import {
  BannerText,
  BannerWrapper,
  BoxImageContainer,
  BoxImageMaisIntegridade,
  BoxImageMapa,
  BoxImageSisbi,
  BoxSegundoContainer,
  BoxTextContainer,
  ButtonContatos,
  ContatosESelosContainer,
  DivCardNutricional,
  DivImageRecipe,
  GradDadosNutricionais,
  H1Receitas,
  H2CardNutricional,
  H2Product,
  HomeContainer,
  ImagePrincipal,
  InfoContainerUm,
  PCardNutricional,
  PImageRecipe,
  PProduct,
} from "./styles";
import sisbi from "../../../assets/images/SISBI.webp";
import maisIntegridade from "../../../assets/images/mais_integridade.webp";
import mapa from "../../../assets/images/MAPA.webp";
import Footer from "../../../components/footer";
import { legend } from "../../../constants/legend_products";
import { useEffect, useState } from "react";
import { ImageWithMagnifier } from "../components/ImageWithMagnifier";
import { receitas } from "../../../constants/revenues";

type product = {
  id: string;
  descricao: string;
  codigo: string;
  embalagemUnidade: string;
  embalagemMaster: string;
  imagem: string[];
  nutricionais: Array<{
    title: string;
    peso: string;
    porcentagem: string;
  }>;
};

const ProductsDescription = () => {
  const { id } = useParams<{ id: string }>();
  const randomIndex01 = Math.floor(Math.random() * receitas.length);
  let randomIndex02 = Math.floor(Math.random() * receitas.length);
  if (receitas.length > 1 && randomIndex02 === randomIndex01) {
    randomIndex02 = (randomIndex01 + 1) % receitas.length;
  }
  const [selectedImage, setSelectedImage] = useState<string>("");
  const [product, setProduct] = useState<product>({
    id: "",
    descricao: "",
    codigo: "",
    embalagemUnidade: "",
    embalagemMaster: "",
    imagem: [],
    nutricionais: [],
  });

  useEffect(() => {
    const foundProduct = legend.find((item) => String(item.id) === String(id));
    if (foundProduct) {
      const imagens = Array.isArray(foundProduct.imagem)
        ? foundProduct.imagem.filter(Boolean)
        : [String(foundProduct.imagem ?? "")];

      setProduct({
        ...foundProduct,
        id: String(foundProduct.id),
        imagem: [...imagens],
      });

      if (imagens.length > 0) {
        setSelectedImage(imagens[0]);
      }
    }
  }, [id]);

  return (
    <HomeContainer>
      <BannerWrapper>
        <BannerText>
          Nossos <br /> Produtos
        </BannerText>
      </BannerWrapper>

      <InfoContainerUm>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}
        >
          {product?.imagem?.[0] ? (
            <ImageWithMagnifier
              src={selectedImage || "/images/imagem02.jpg"}
              alt={product.descricao || "Imagem do produto"}
              zoom={0.3} // ajuste o nível de ampliação
              size={410} // tamanho da telinha ampliada (px)
            />
          ) : (
            <ImagePrincipal
              src="/images/imagem02.jpg"
              alt="Imagem não disponível"
            />
          )}

          <div
            style={{
              display: "flex",
              gap: "10px",
              marginTop: "15px",
              width: "100%",
              flexWrap: "wrap",
            }}
          >
            {product.imagem.map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`Miniatura ${index + 1}`}
                style={{
                  width: "auto",
                  height: "auto",
                  maxHeight: "50px",
                  maxWidth: "65px",
                  objectFit: "cover",
                  borderRadius: "8px",
                  cursor: "pointer",
                  border:
                    selectedImage === img
                      ? "2px solid #881C15"
                      : "2px solid transparent",
                  transition: "0.2s ease-in-out",
                }}
                onClick={() => setSelectedImage(img ?? "")}
              />
            ))}
          </div>

          <p style={{ marginTop: "10px", fontSize: "14px" }}>
            <span style={{ fontWeight: "bold" }}>Atenção:</span> Embalagem
            online pode diferir da disponível em lojas durante processo de
            atualização. A qualidade permanece a mesma.
          </p>

          <H1Receitas>Sugestões de receitas</H1Receitas>

          <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
            <DivImageRecipe
              $imageUrl={
                receitas[randomIndex01]?.image || "/images/imagem01.jpg"
              }
              onClick={() =>
                (window.location.href = `/revenues/${receitas[randomIndex01]?.id}`)
              }
            >
              <PImageRecipe>{receitas[randomIndex01]?.title}</PImageRecipe>
            </DivImageRecipe>

            <DivImageRecipe
              $imageUrl={
                receitas[randomIndex02]?.image || "/images/imagem02.jpg"
              }
              onClick={() =>
                (window.location.href = `/revenues/${receitas[randomIndex02]?.id}`)
              }
            >
              <PImageRecipe>{receitas[randomIndex02]?.title}</PImageRecipe>
            </DivImageRecipe>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            borderRadius: "10px",
            flexDirection: "column",
            gap: "10px",
            width: "100%",
          }}
        >
          <BoxSegundoContainer>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "20px",
                alignItems: "center",
              }}
            >
              <H2Product>{product.descricao}</H2Product>
              <PProduct>{product.codigo}</PProduct>
            </div>
          </BoxSegundoContainer>
          <GradDadosNutricionais>
            <H2CardNutricional>Tabela Nutricional</H2CardNutricional>
            <PCardNutricional>(por 30g - 1/4 de prato raso)</PCardNutricional>

            <DivCardNutricional>
              <div key={product.id} style={{ marginBottom: "40px" }}>
                <table
                  style={{
                    width: "100%",
                    color: "#881C15",
                    borderCollapse: "collapse",
                    fontSize: "14px",
                  }}
                >
                  <thead>
                    <tr
                      style={{
                        textAlign: "left",
                      }}
                    >
                      <th style={{ padding: "8px" }}>Nutriente</th>
                      <th style={{ padding: "8px" }}>Quant. por 100g</th>
                      <th style={{ padding: "8px" }}>Quant. por 30g</th>
                      <th style={{ padding: "8px" }}>%VD*</th>
                    </tr>
                  </thead>
                  <tbody>
                    {product.nutricionais.map((item, index) => {
                      // calcula a quantidade por 30g (exemplo: 30% de 100g)
                      const peso30g =
                        parseFloat(item.peso.replace(",", ".")) * 0.3;
                      const pesoFormatado =
                        Number.isNaN(peso30g) || item.peso === "0"
                          ? "0"
                          : peso30g.toFixed(1).replace(".", ",");

                      return (
                        <tr
                          key={index}
                          style={
                            index % 2 === 0 ? { background: "#fdecd7ff" } : {}
                          }
                        >
                          <td style={{ padding: "6px" }}>{item.title}</td>
                          <td style={{ padding: "6px" }}>{item.peso}</td>
                          <td style={{ padding: "6px" }}>{pesoFormatado}</td>
                          <td style={{ padding: "6px" }}>{item.porcentagem}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              <p
                style={{
                  marginTop: "10px",
                  color: "#881C15",
                  fontSize: "13px",
                }}
              >
                *Percentual de valores diários fornecidos pela porção.
              </p>

              <p
                style={{ marginTop: "8px", color: "#881C15", fontSize: "13px" }}
              >
                <strong>Ingredientes:</strong> Carne de bovina, cloreto de sódio
                (sal) e sal de cura (Nitrato de Sódio INS 250 e Nitrato de Sódio
                INS 251).
              </p>

              <p
                style={{
                  fontSize: "13px",
                  color: "#881C15",
                  fontWeight: "bold",
                }}
              >
                NÃO CONTÉM GLÚTEN.
              </p>

              <p
                style={{ fontSize: "13px", color: "#881C15", marginTop: "6px" }}
              >
                MANTER EM LOCAL SECO E FRESCO.
              </p>

              <p style={{ fontSize: "13px", color: "#881C15" }}>
                Após aberta a embalagem conservar o produto sob refrigeração
                entre 1 e 10°C por até 8 dias.
              </p>
            </DivCardNutricional>
          </GradDadosNutricionais>
        </div>
      </InfoContainerUm>

      <ContatosESelosContainer>
        <BoxTextContainer>
          <div>
            <h2>Vamos fazer negócios?</h2>
            <p>Fale com um especialista</p>
          </div>
          <ButtonContatos
            onClick={() => {
              window.location.href = "/contact-us";
            }}
          >
            CONTATO
          </ButtonContatos>
        </BoxTextContainer>
        <BoxImageContainer>
          <BoxImageSisbi src={sisbi} alt="SISBI" />
          <BoxImageMaisIntegridade src={maisIntegridade} />
          <BoxImageMapa src={mapa} alt="Mapa" />
        </BoxImageContainer>
      </ContatosESelosContainer>

      <Footer />
    </HomeContainer>
  );
};
export default ProductsDescription;
